<template>
    <section class="tekst light purple">
        <circles-layout></circles-layout>
        <h1>Samen in beweging</h1>
        <p>De pandemie, die in 2021 nog in volle gang was, onderstreept het belang en de rol van het onderwijs. Onderwijs is niet alleen essentieel voor de cognitieve ontwikkeling van jongeren, maar speelt ook een grote rol bij de ontwikkeling van sociaalmaatschappelijke en emotionele vaardigheden. We zetten nu stevig in op socialisatie om de impact te beperken.</p>

        <p>Het onderwijs ging ook in 2021 gewoon door. Onderwijsgroep Tilburg slaagde er samen met regionale bedrijven en instellingen in om invulling te geven aan stages en praktijkvorming. De inspectie is zeer te spreken over het elan in de organisatie, de sturing en de kwaliteitsborging. Daar zijn we trots op. We blijven ons onderwijs continu moderniseren en flexibiliseren aan de hand van de maatschappelijke, economische en technologische ontwikkelingen in onze omgeving. Ons onderwijsaanbod in het kader van Leven Lang Ontwikkelen en de ontwikkelingen van nieuw onderwijs binnen de innovatie-omgeving van MindLabs zijn daar voorbeelden van.</p>

        <p>Een kleine greep uit de hoogtepunten van 2021 waar we trots op zijn:</p>

        <ul>
            <li>Onze modestudente La Rose Kifu werd gekozen tot ambassadeur ROC Tilburg;</li>
            <li>Kirsten Cuppen, docent bij de School voor Mechatronica, Werktuigbouwkunde en Metaaltechniek won de landelijke verkiezing van beste mbo-docent;</li>
            <li>Campus 013 had, ondanks de demografische ontwikkelingen, de helft meer aanmeldingen dan de jaren ervoor.</li>
        </ul>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
    ul{
        text-align: left !important;
    }
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'OntwikkelingIntro',
        meta: {
            title: 'OntwikkelingIntro',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
